import { useState } from "react";
import Checkbox from "@rio-cloud/rio-uikit/Checkbox";
import { ITruckerPayPlanData } from "../../../../models/truckerPayPlan";
import { Button, Dialog, Tag } from "@rio-cloud/rio-uikit";

import "../../index.css";

interface IBudgetBalanceCardProps {
  truckerPay?: ITruckerPayPlanData;
  isMobile?: boolean;
}

const formatCurrency = (value: number): string => {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const BudgetBalanceCard = (props: IBudgetBalanceCardProps) => {
  const {
    truckerPay,
    isMobile,
  } = props;

  const [showDialog, setShowDialog] = useState(false);

  const paddingX = isMobile ? 'px-2' : 'px-6';
  const balance = truckerPay?.availableCoverageBalance ?? 0;

  return (
    <div className={`mb-6 ${paddingX}`}>
      <div
        className={`
          flex ${isMobile ? 'flex-col' : 'flex-row'} ${isMobile ? 'gap-2' : 'items-center justify-between'} padding-y-5 padding-x-15 margin-bottom-10
          ${balance > 0 ? 'budget-coverage-balance' : 'budget-coverage-insufficient-balance'}
          `}
      > 
        <div>
          <div className="text-medium mr-10 text-size-18">Saldo disponível</div>
          <p>Saldo utilizado para serviços adicionais e complementos de franquia</p>
        </div>
        <div className={`flex flex-col ${isMobile ? 'items-start' : 'items-end'} shrink-0 ${isMobile ? 'pt-2' : ''}`}>
          <span className={`font-bold ${balance > 0 ? '' : 'budget-coverage-insufficient-balance-value'} ${isMobile ? 'text-size-14' : 'text-size-20'}`}>
            {formatCurrency(balance)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BudgetBalanceCard;
